import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '/h5c/', 
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@views/layout/index'),
            redirect: 'home',
            children: [
                {
                    path: '/home',
                    name: '首页',
                    component: () => import(/* webpackChunkName: "home-page" */ '@views/home/index'),
                    meta: { title: '分销商注册', requireAuth: false, index: 0, },
                },
                {
                    path: '/login',
                    name: '登录',
                    component: () => import(/* webpackChunkName: "home-page" */ '@views/home/login'),
                    meta: { title: '登录', requireAuth: false, index: 0, },
                },
                {
                    path: '/C',
                    name: '扫码主页',
                    component: () => import(/* webpackChunkName: "home-page" */ '@views/customer/index'),
                    meta: { title: '', requireAuth: false, index: 0, },
                },
                {
                    path: '/:qrcode',
                    name: '扫码主页',
                    component: () => import(/* webpackChunkName: "home-page" */ '@views/customer/index'),
                    meta: { title: '', requireAuth: false, index: 0, },
                },
                {
                    path: '/outbill',
                    name: '出库单',
                    component: () => import(/* webpackChunkName: "home-page" */ '@views/customer/outbill'),
                    meta: { title: '出库单', requireAuth: false, index: 0, },
                },
            ],
            meta: {
                index: 0, // 层级，用于判断过渡动画的效果
                requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
            }
        }
    ]
})

// router.beforeEach(function (to, from, next) {
//     if (to.meta.title) {  // || store.state.title
//         Vue.refreshTitle(to.meta.title); //|| store.state.title
//     }
//     next();
// }
export default router